import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Card, Col, Icon, Row, Select, Skeleton, Statistic, Tooltip} from 'antd';
import TranslatedText from '../../TranslatedText';
import {makeAction} from '../../../redux/actions/makeAction';
import {FETCH_EARNINGS} from '../../../redux/actions/actionTypes';
import {earningsResults, isLoadingEarnings, isPendingBelowThreshold} from '../../../redux/selectors/stats';
import moment from 'moment';

const defaultState = {
  currentTimespanLabel: 'dashboard.earings.todayEstimate',
  pastTimespanLabel: 'dashboard.earings.yesterday',
};

const timespanLabels = Object.freeze({
  day: {currentTimespanLabel: 'dashboard.earings.todayEstimate', pastTimespanLabel: 'dashboard.earings.yesterday'},
  week: {currentTimespanLabel: 'dashboard.earings.weekEstimate', pastTimespanLabel: 'dashboard.earings.lastWeek'},
  month: {currentTimespanLabel: 'dashboard.earings.monthEstimate', pastTimespanLabel: 'dashboard.earings.lastMonth'},
});

class Earnings extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {...defaultState};
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleFilterChange(e) {
    this.props.fetchEarnings(e);
    this.setState({...timespanLabels[e]});
  }

  render() {
    return (
      <React.Fragment>
        <Card
          id="earnings-card"
          title={<TranslatedText transKey="dashboard.earings.title"/>}
          extra={<Select defaultValue="day" style={{width: 140}} onChange={this.handleFilterChange}>
            <Select.Option value="day"><TranslatedText transKey="dashboard.filters.today"/></Select.Option>
            <Select.Option value="week"><TranslatedText transKey="dashboard.filters.thisweek"/></Select.Option>
            <Select.Option value="month"><TranslatedText transKey="dashboard.filters.thismonth"/></Select.Option>
          </Select>}
          bordered={false}
        >
          <Row>
            <Col span={15}>
              {
                this.props.isLoading
                  ? <Skeleton active title={{width: '30%'}} paragraph={{rows: 1, width: '50%'}}/>
                  : <Statistic title={<TranslatedText transKey={this.state.currentTimespanLabel}/>}
                               value={this.props.results.current || 'None'} precision={7}/>
              }
            </Col>
            <Col span={8}>
              {
                this.props.isLoading
                  ? <Skeleton active title={{width: '30%'}} paragraph={{rows: 1, width: '50%'}}/>
                  : <Statistic title={<TranslatedText transKey={this.state.pastTimespanLabel}/>}
                               value={this.props.results.previous || 'None'} precision={7}/>
              }
            </Col>
            <Col span={1}>
              <Tooltip title={<TranslatedText transKey="dashboard.earings.toolTip"/>} placement="right">
                <Icon type="info-circle"/>
              </Tooltip>
            </Col>
          </Row>
        </Card>
        <Card id="balance-card" bordered={false}>
          {
            this.props.isLoading
              ? <Skeleton active title={false} paragraph={{rows: 3, width: '100%'}}/>
              : <div>
                <div className="earnings-balance-statistics">
                    <span className="earnings-balance-statistics-header">
                      <TranslatedText transKey="dashboard.earings.totalpaid"/>
                    </span>
                  <span className="earnings-balance-statistics-content">
                      {this.props.results.total} BTCV
                    </span>
                </div>
                <div className="earnings-balance-statistics">
                    <span className="earnings-balance-statistics-header">
                      <TranslatedText transKey="dashboard.earings.lastpayment"/>
                    </span>
                  <span className="earnings-balance-statistics-content">
                      {this.props.results.last_payment ? moment(this.props.results.last_payment).format('L') : 'None'}
                    </span>
                </div>
                <div className="earnings-balance-statistics">
                  <span className="earnings-balance-statistics-header">
                    <TranslatedText transKey="dashboard.earings.pendingpayment"/>
                  </span>
                  {
                    this.props.pendingBelowThreshold
                      ? <Tooltip arrowPointAtCenter overlayStyle={{width: 190}} placement="bottom" title={<TranslatedText transKey="dashboard.earings.belowthreshold"/>} overlayClassName="earinigs-below-threshold-tooltip">
                        <span className="earnings-balance-statistics-content has-error">
                          {this.props.results.pending ? `${this.props.results.pending} BTCV` : 'None'}
                        </span>
                      </Tooltip>
                      : <span className="earnings-balance-statistics-content">
                        {this.props.results.pending ? `${this.props.results.pending} BTCV` : 'None'}
                      </span>
                  }
                </div>
              </div>
          }
        </Card>
      </React.Fragment>
    );
  }
}

Earnings.propTypes = {
  results: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pendingBelowThreshold: PropTypes.bool.isRequired,
  fetchEarnings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  results: earningsResults(state),
  pendingBelowThreshold: isPendingBelowThreshold(state),
  isLoading: isLoadingEarnings(state),
});

const mapDispatchToProps = {
  fetchEarnings: makeAction(FETCH_EARNINGS),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Earnings);



// WEBPACK FOOTER //
// /src/components/pages/dashboard/Earnings.jsx